import gql from "../gql";
import Learning from "../fragments/Learning";
export default gql `
  mutation unfavorite($name: String!, $type: LearningKind!) {
    unfavorite(input: { learning: { name: $name, type: $type } }) {
      __typename
      learning {
        ...LearningSummaryOnDetail
      }
    }
  }
  fragment LearningSummaryOnDetail on LearningSummary {
    favorite
    description
    ...Learning
  }
  ${Learning}
`;
